
/*
 * Copyright (c) Fing Ltd. All rights reserved.
 */

import VisaImg from "../assets/image/100x60/Visa-dark.png"
import MastercardImg from "../assets/image/100x60/MasterCard-dark.png"
import DiscoverImg from "../assets/image/100x60/Discover-dark.png"
import AmericanExpressImg from "../assets/image/100x60/AmericanExpress-dark.png"
import DinersImg from "../assets/image/100x60/DinersClub-dark.png"
import JcbImg from "../assets/image/100x60/JCB-dark.png"
import UnionPayImg from "../assets/image/100x60/UnionPay-dark.png"

export const FING_PLAN_FREE = 'FREE';
export const FING_PLAN_STARTER = 'STARTER';
export const FING_PLAN_PREMIUM = 'PREMIUM';
export const FING_PLAN_PROFESSIONAL = 'PROFESSIONAL';

export const FING_ACCOUNT_FREE = 'FREE';
export const FING_ACCOUNT_STARTER = 'STARTER';
export const FING_ACCOUNT_PREMIUM = 'PREMIUM';
export const FING_ACCOUNT_PROFESSIONAL = 'PROFESSIONAL';

export const FING_ROLE_VIEWER = 'VIEWER';
export const FING_ROLE_EDITOR = 'EDITOR';
export const FING_ROLE_CONTRIBUTOR = 'CONTRIBUTOR';
export const FING_ROLE_INSTALLER = 'INSTALLER';
export const FING_ROLE_MANAGER = 'MANAGER';
export const FING_ROLE_OWNER = 'OWNER';

export const FING_ADS_FREE_1Y = "ads_free_1yr";
export const FING_ADS_FREE_1M = "ads_free_1mth"; // TO CHECK 

export const FING_SUBSTATUS_INCOMPLETE = "INCOMPLETE";
export const FING_SUBSTATUS_INCOMPLETE_EXPIRED = "INCOMPLETE_EXPIRED";
export const FING_SUBSTATUS_TRIALING = "TRIALING";
export const FING_SUBSTATUS_ACTIVE = "ACTIVE";
export const FING_SUBSTATUS_PAST_DUE = "PAST_DUE";
export const FING_SUBSTATUS_CANCELED = "CANCELED";
export const FING_SUBSTATUS_UNPAID = "UNPAID";

export const FING_MOBSTATUS_TRIAL = "TRIAL";
export const FING_MOBSTATUS_ACTIVE = "ACTIVE";
export const FING_MOBSTATUS_CANCELLED = "CANCELLED";
export const FING_MOBSTATUS_SUSPENDED = "SUSPENDED";
export const FING_MOBSTATUS_EXPIRED = "EXPIRED";

export const FING_PAYMENTSTATUS_REQUIRES_ACTION = "requires_action";

export const MOBILE_PLATFORM_PLAYSTORE = "PLAY_STORE";
export const MOBILE_PLATFORM_APPSTORE = "APP_STORE";
export const MOBILE_PLATFORM_APPGALLERY = "APP_GALLERY";

export const INTERVAL_YEAR = 'YEAR';
export const INTERVAL_MONTH = 'MONTH';
export const INTERVAL_WEEK = "WEEK";
export const INTERVAL_DAY = 'DAY';

export const PAYMENT_FORM_ADD_CARD = "ADD_CARD";
export const PAYMENT_FORM_SUBSCRIBE = "PAYMENT_FORM_SUBSCRIBE";
export const PAYMENT_FORM_EDIT_CUSTOMER = "EDIT_CUSTOMER";

export const FING_INVALIDINPUT_CARD = 'CARD_INPUT';
export const FING_INVALIDINPUT_VAT_NAME = 'VAT_NAME_INPUT';
export const FING_INVALIDINPUT_VAT_NUMBER = 'VAT_NUMBER_INPUT';
export const FING_INVALIDINPUT_REDEEM_CODE = 'REDEEM_CODE_INPUT';

// See https://stackoverflow.com/questions/19373860/convert-currency-names-to-currency-symbol
const currencySymbols = {
    'USD': '$', // US Dollar
    'EUR': '€', // Euro
    'CRC': '₡', // Costa Rican Colón
    'GBP': '£', // British Pound Sterling
    'ILS': '₪', // Israeli New Sheqel
    'INR': '₹', // Indian Rupee
    'JPY': '¥', // Japanese Yen
    'KRW': '₩', // South Korean Won
    'NGN': '₦', // Nigerian Naira
    'PHP': '₱', // Philippine Peso
    'PLN': 'zł', // Polish Zloty
    'PYG': '₲', // Paraguayan Guarani
    'THB': '฿', // Thai Baht
    'UAH': '₴', // Ukrainian Hryvnia
    'VND': '₫', // Vietnamese Dong
};

export function enrichOfferOptions(options) {
    const projectedYearlyAmounts = options
        .filter(offer => matchesCaseInsensitive(offer.billingCycle, INTERVAL_MONTH))
        .reduce((accumulator, offer) => { accumulator[offer.productId] = offer.standardAmount * 12; return accumulator}, {});
    options.filter(offer => matchesCaseInsensitive(offer.billingCycle, INTERVAL_YEAR)).forEach(offer => {
        const amount = offer.offerAmount || offer.standardAmount;
        offer.normalizedAmount = Math.floor(amount / 12 * 100) / 100;
        offer.projectedAmount = projectedYearlyAmounts[offer.productId];
        return offer;
    });
    options.forEach(offer => {
        const currentAmount = offer.offerAmount || offer.standardAmount;
        const comparisonAmount = offer.projectedAmount || offer.standardAmount
        if (currentAmount !== comparisonAmount) {
            let discountPct = 100 - Math.round(currentAmount / comparisonAmount * 100);
            discountPct = Math.round(discountPct / 5) * 5;  // Round percentages to multiples of 5
            offer.discountPct = discountPct;
        }
    } );
}

export function matchesCaseInsensitive(s1, s2) {
    return s1 && s2 && s1.toLowerCase() === s2.toLowerCase();
}

export function promoCodeFromParams(queryParams) {
    return queryParams && queryParams.has("promo_code") ? queryParams.get("promo_code") : null;
}

export function discountOfferFromParams(queryParams) {
    return queryParams && queryParams.has("discount_offer") ? queryParams.get("discount_offer") : null;
}

export function planIdFromParams(queryParams) {
    const planId = queryParams && queryParams.has("plan") ? queryParams.get("plan").toUpperCase() : FING_PLAN_FREE;
    if (planId === FING_PLAN_STARTER || planId === FING_PLAN_PREMIUM || planId === FING_PLAN_PROFESSIONAL)
        return planId;
    else
        return FING_PLAN_FREE;
}

export function productIdFromParams(queryParams) {
    const productId = queryParams && queryParams.has("product") ? queryParams.get("product").toUpperCase() : FING_PLAN_PREMIUM;
    if (productId === FING_PLAN_FREE || productId === FING_PLAN_STARTER || productId === FING_PLAN_PREMIUM || productId === FING_PLAN_PROFESSIONAL)
        return productId;
    else
        return FING_PLAN_PREMIUM;
}

export function productPrettyName(productId) {
    if (!productId) return productId;

    let name = productId;  // Fallback to the ID, worst case scenario
    if (productId.toUpperCase() === FING_PLAN_FREE) name = "Free";
    else if (productId.toUpperCase() === FING_PLAN_STARTER) name = "Starter";
    else if (productId.toUpperCase() === FING_PLAN_PREMIUM) name = "Premium";
    else if (productId.toUpperCase() === FING_PLAN_PROFESSIONAL) name = "Professional";
    return name;
}

export function productPrettyDescription(productId) {
    if (!productId) return productId;

    let text = productId;  // Fallback to the ID, worst case scenario
    if (productId.toUpperCase() === FING_PLAN_FREE) text = "Best for occasional usage and basic network management";
    else if (productId.toUpperCase() === FING_PLAN_STARTER) text = "Best for 24/7 home monitoring and extended network management.";
    else if (productId.toUpperCase() === FING_PLAN_PREMIUM) text = "Best for professional use and advanced network security.";
    else if (productId.toUpperCase() === FING_PLAN_PROFESSIONAL) text = "Best for businesses, IT consultants and teams.";
    return text;
}

export function productFeatureListTitle(productId) {
    if (!productId) return productId;

    let text = productId;  // Fallback to the ID, worst case scenario
    if (productId.toUpperCase() === FING_PLAN_FREE) text = "Free for life";
    else if (productId.toUpperCase() === FING_PLAN_STARTER) text = "Anything in Free, plus essential tools for surveillance.";
    else if (productId.toUpperCase() === FING_PLAN_PREMIUM) text = "Anything in Starter, plus advanced tools for protection.";
    else if (productId.toUpperCase() === FING_PLAN_PREMIUM) text = "Anything in Premium, plus collaboration and supervision.";
    return text;
}

export function productFeatureList(productId) {
    if (!productId) return [];

    let set = [];  // Fallback to the ID, worst case scenario
    if (productId.toUpperCase() === FING_PLAN_FREE) set = [];
    else if (productId.toUpperCase() === FING_PLAN_STARTER) set = [
        "Unlimited automated scans",
        "7 days event timeline",
        "Router vulnerability checks",
        "Hidden cameras detector",
        "1 Monitored Network",
    ];
    else if (productId.toUpperCase() === FING_PLAN_PREMIUM) set = [
        "Continuous monitoring",
        "Full event timeline",
        "Block and limit Internet",
        "Auto-block of new unknown devices",
        "2 Monitored Networks",
        "Mobile & email notifications",
    ];
    else if (productId.toUpperCase() === FING_PLAN_PROFESSIONAL) set = [
        "Shared workspaces",
        "Team access",
        "Search across networks",
        "Automated reports",
        "3+ Monitored Networks",
        // "Slack integration",
    ];
    return set;
}

export function currencySymbol(currencyName) {
    return currencyName ? currencySymbols[currencyName.toUpperCase()] : undefined;
}

export function intervalIdFromParams(queryParams) {
    const intervalId = queryParams && queryParams.has("interval") ? queryParams.get("interval").toUpperCase() : INTERVAL_YEAR;
    if (intervalId === INTERVAL_MONTH || intervalId === INTERVAL_YEAR)
        return intervalId;
    else
        return INTERVAL_YEAR;
}

export function mobilePlatformIcon(platform) {
    let faIcon;
    if (platform === MOBILE_PLATFORM_PLAYSTORE) faIcon = "fab fa-google-play";
    else if (platform === MOBILE_PLATFORM_APPSTORE) faIcon = "fab fa-apple";
    else if (platform === MOBILE_PLATFORM_APPGALLERY) faIcon = "fab fa-android";
    return faIcon;
}

export function mobilePlatformPrettyName(platform) {
    let platformName = platform;  // Fallback to the ID, worst case scenario
    if (platform === MOBILE_PLATFORM_PLAYSTORE) platformName = "Play Store";
    else if (platform === MOBILE_PLATFORM_APPSTORE) platformName = "App Store";
    else if (platform === MOBILE_PLATFORM_APPGALLERY) platformName = "App Gallery";
    return platformName;
}

export function planPrettyName(planId) {
    let planName = planId;  // Fallback to the ID, worst case scenario
    if (planId === FING_PLAN_FREE) planName = "Free";
    else if (planId === FING_PLAN_STARTER) planName = "Starter";
    else if (planId === FING_PLAN_PREMIUM) planName = "Premium";
    else if (planId === FING_PLAN_PROFESSIONAL) planName = "Professional";
    return planName;
}


export function isFreeProduct(planId) {
    return (planId && planId.toUpperCase() === FING_PLAN_FREE);
}

export function accountTypePrettyName(accountType) {
    let accountName = accountType;  // Fallback to the ID, worst case scenario
    if (accountType === FING_ACCOUNT_FREE) accountName = "Free";
    else if (accountType === FING_ACCOUNT_STARTER) accountName = "Starter";
    else if (accountType === FING_ACCOUNT_PREMIUM) accountName = "Premium";
    else if (accountType === FING_ACCOUNT_PROFESSIONAL) accountName = "Professional";
    return accountName;
}

export function isSamePlan(accountType, planId) {
    return (accountType === FING_ACCOUNT_FREE && planId === FING_PLAN_FREE) ||
        (accountType === FING_ACCOUNT_STARTER && planId === FING_PLAN_STARTER) ||
        (accountType === FING_ACCOUNT_PREMIUM && planId === FING_PLAN_PREMIUM) ||
        (accountType === FING_ACCOUNT_PROFESSIONAL && planId === FING_PLAN_PROFESSIONAL)
        ;
}

export function formatTitle(text) {
    if (!text) return "";

    text = text.toLowerCase().replace(/ /g, "_");

    let splittedText = text.split("_");
    let toReturn = [];
    for (let word of splittedText) {
        toReturn.push(word.charAt(0).toUpperCase() + word.slice(1));
    }

    return toReturn.join(" ");
}

export function paymentCardDetails(card) {

    if (!card || !card.brand) return { brand: null, cardImage: null, ObfuscatedDigits: "", last4: "" };

    const base = {
        last4: card.last4 || card.lastFourDigits,
        expirationMonth: card.expMonth,
        expirationYear: card.expYear
    }
    switch (card.brand) {
        case "visa":
            return Object.assign(base, {
                brand: "VISA",
                cardImage: VisaImg,
                ObfuscatedDigits: "•••• •••• •••• ",
            });
        case "mastercard":
            return Object.assign(base, {
                brand: "MasterCard",
                cardImage: MastercardImg,
                ObfuscatedDigits: "•••• •••• •••• ",
            });
        case "discover":
            return Object.assign(base, {
                brand: "Discover",
                cardImage: DiscoverImg,
                ObfuscatedDigits: "•••• •••• •••• ",
            });
        case "amex":
            return Object.assign(base, {
                brand: "American Express",
                cardImage: AmericanExpressImg,
                ObfuscatedDigits: "•••• ••••• •",
            });
        case "diners":
            return Object.assign(base, {
                brand: "Diners",
                cardImage: DinersImg,
                ObfuscatedDigits: "xxxx xxxx xxxx ",
            });
        case "jcb":
            return Object.assign(base, {
                brand: "JCB",
                cardImage: JcbImg,
                ObfuscatedDigits: "xxxx xxxx xxxx ",
            });
        case "unionpay":
            return Object.assign(base, {
                brand: "UnionPay",
                cardImage: UnionPayImg,
                ObfuscatedDigits: "xxxx xxxx xxxx ",
            });
        default:
            return {
                brand: null,
                cardImage: null,
                ObfuscatedDigits: "",
                last4: "",
                expirationMonth: "",
                expirationYear: "",
            }
    }
}

export function formatInvoiceOrSubAmount(amount, currency, interval) {
    let toReturn = "";
    let safeInterval = interval ? interval.toUpperCase() : null;
    let safeValue = amount ? parseFloat(amount / 100) : 0;
    safeValue = safeValue.toPrecision(3);

    // this is because toPrecision ( the same toFixed ) is going to round automatically in that way I avoid that
    let charAfterComma = safeValue.split('.');
    if (charAfterComma && charAfterComma[1] && charAfterComma[1].length > 2) {
        safeValue = safeValue.slice(0, -1);
    }

    toReturn += safeValue;

    switch (currency) {
        case "eur":
            toReturn += "€";
            break;
        case "usd":
            toReturn += "$";
            break;
        case "gbp":
            toReturn += "£";
            break;
        default:
            break;
    }

    switch (safeInterval) {

        case INTERVAL_YEAR:
            toReturn += "/yearly";
            break;
        case INTERVAL_MONTH:
            toReturn += "/monthly";
            break;
        case INTERVAL_WEEK:
            toReturn += "/weekly";
            break;
        case INTERVAL_DAY:
            toReturn += "/daily";
            break;
        default:
            break;
    }

    return toReturn;
}

export function toPrettySubscriptionStatus(status, cancelAtPeriodEnd) {
    if (!status) return null;
    switch (status) {
        case FING_SUBSTATUS_INCOMPLETE:
            return { label: "Incomplete", type: "warning" };
        case FING_SUBSTATUS_INCOMPLETE_EXPIRED:
            return { label: "Incomplete Expired", type: "danger" };
        case FING_SUBSTATUS_TRIALING:
        case FING_MOBSTATUS_TRIAL:
            return { label: "Trialing", type: "primary" };
        case FING_SUBSTATUS_ACTIVE:
        case FING_MOBSTATUS_ACTIVE:
            return cancelAtPeriodEnd === true ? { label: "Cancelled", type: "secondary" } : { label: "Active", type: "success" };
        case FING_SUBSTATUS_PAST_DUE:
            return { label: "Past due", type: "danger" };
        case FING_SUBSTATUS_CANCELED:
        case FING_MOBSTATUS_CANCELLED:
            return { label: "Canceled", type: "secondary" };
        case FING_SUBSTATUS_UNPAID:
            return { label: "Unpaid", type: "danger" };
        case FING_MOBSTATUS_EXPIRED:
            return { label: "Expired", type: "secondary" };
        default:
            return null
    }
}

export function toPrettyPaymentStatus(paymentStatus) {
    if (!paymentStatus) return paymentStatus;

    switch (paymentStatus) {
        case "canceled": return "Cancelled";
        case "processing": return "Processing";
        case "requires_action": return "Requires action";
        case "requires_capture": return "Requires capture";
        case "requires_confirmation": return "Requires confirmation"
        case "requires_payment_method": return "Requires payment method";
        case "succeeded": return "Succeeded";
        default: return paymentStatus;
    }
}

export function formatBillingAddress(address) {
    let toReturn = [];

    if (!address) {
        return "";
    }

    if (address.addressLine2) {
        toReturn.push(address.addressLine2);
    }
    if (address.addressLine1) {
        toReturn.push(address.addressLine1);
    }
    if (address.addressState) {
        toReturn.push(address.addressState);
    }
    if (address.addressCountry) {
        toReturn.push(address.addressCountry);
    }
    if (address.addressPostalCode) {
        toReturn.push(address.addressPostalCode);
    }

    return toReturn.join(', ');

}

export function rolePrettyName(role) {
    let roleName = role;  // Fallback to the ID, worst case scenario
    if (role === FING_ROLE_VIEWER) roleName = "Viewer";
    else if (role === FING_ROLE_EDITOR) roleName = "Editor";
    else if (role === FING_ROLE_CONTRIBUTOR) roleName = "Contributor";
    else if (role === FING_ROLE_INSTALLER) roleName = "Installer";
    else if (role === FING_ROLE_MANAGER) roleName = "Manager";
    else if (role === FING_ROLE_OWNER) roleName = "Owner";
    return roleName;
}

export function rolePrettyDescription(role) {
    let roleDesc = "";  // Fallback to the ID, worst case scenario
    if (role === FING_ROLE_VIEWER) roleDesc = "Reads only";
    else if (role === FING_ROLE_EDITOR) roleDesc = "Customizes names and settings";
    else if (role === FING_ROLE_CONTRIBUTOR) roleDesc = "Scans to add and update networks";
    else if (role === FING_ROLE_INSTALLER) roleDesc = "Activates monitoring";
    else if (role === FING_ROLE_MANAGER) roleDesc = "Removes networks and monitoring";
    else if (role === FING_ROLE_OWNER) roleDesc = "Invite and manages users";
    return roleDesc;
}

export function inferMobileBillingCycle(productId) {
    if (!productId) return INTERVAL_MONTH;
    if (productId.toLowerCase().endsWith("1yr") || productId.toLowerCase().endsWith("1y")) return INTERVAL_YEAR;
    return INTERVAL_MONTH;
}

